/**
 * VAST documents interface.
 * this file has copied from https://github.com/etf1/IAB
 */
/**
 * Ad types.
 */
export var AdType;
(function (AdType) {
    AdType["inline"] = "inline";
    AdType["wrapper"] = "wrapper";
})(AdType || (AdType = {}));
/**
 * Ad pricing models.
 */
export var AdPricingModel;
(function (AdPricingModel) {
    // Cost per click.
    AdPricingModel["cpc"] = "cpc";
    // Cost per mille.
    AdPricingModel["cpm"] = "cpm";
    // Cost per engagement.
    AdPricingModel["cpe"] = "cpe";
    // Cost per view.
    AdPricingModel["cpv"] = "cpv";
})(AdPricingModel || (AdPricingModel = {}));
/**
 * Creative types.
 */
export var CreativeType;
(function (CreativeType) {
    // Linear ad.
    CreativeType["linear"] = "linear";
})(CreativeType || (CreativeType = {}));
/**
 * Tracking event types.
 */
export var TrackingEventType;
(function (TrackingEventType) {
    TrackingEventType["creativeView"] = "creativeView";
    TrackingEventType["start"] = "start";
    TrackingEventType["firstQuartile"] = "firstQuartile";
    TrackingEventType["midpoint"] = "midpoint";
    TrackingEventType["thirdQuartile"] = "thirdQuartile";
    TrackingEventType["complete"] = "complete";
    TrackingEventType["mute"] = "mute";
    TrackingEventType["unmute"] = "unmute";
    TrackingEventType["pause"] = "pause";
    TrackingEventType["rewind"] = "rewind";
    TrackingEventType["resume"] = "resume";
    TrackingEventType["fullscreen"] = "fullscreen";
    TrackingEventType["exitFullscreen"] = "exitFullscreen";
    TrackingEventType["expand"] = "expand";
    TrackingEventType["collapse"] = "collapse";
    TrackingEventType["acceptInvitation"] = "acceptInvitation";
    TrackingEventType["close"] = "close";
    TrackingEventType["skip"] = "skip";
    TrackingEventType["progress"] = "progress";
})(TrackingEventType || (TrackingEventType = {}));
/**
 * mimeType enum
 */
export var mimetype;
(function (mimetype) {
    mimetype["IMAGE_GIF"] = "image/gif";
    mimetype["IMAGE_PNG"] = "image/png";
    mimetype["IMAGE_JPEG"] = "image/jpeg";
    mimetype["IMAGE_JPG"] = "image/jpg";
    mimetype["VIDEO_MP4"] = "video/mp4";
})(mimetype || (mimetype = {}));
/**
 * Mediafile delivery types.
 */
export var DeliveryType;
(function (DeliveryType) {
    DeliveryType[DeliveryType["streaming"] = 1] = "streaming";
    DeliveryType[DeliveryType["progressive"] = 2] = "progressive";
})(DeliveryType || (DeliveryType = {}));
//# sourceMappingURL=VAST3.js.map